import { LitElement, html } from './-global.min.js'

class HHProductCard extends LitElement {
  get anchor() {
    return this.querySelector('.js-anchor')
  }

  get variantButtons() {
    return [...this.querySelectorAll('.js-swatch')]
  }

  connectedCallback() {
    super.connectedCallback()
    this.variantButtons.forEach((button) => {
      button.addEventListener('click', this.onClickHandler.bind(this))
    })
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.variantButtons.forEach((button) => {
      button.removeEventListener('click', this.onClickHandler)
    })
  }

  async onClickHandler(event) {
    event.preventDefault()
    this.anchor.href = event.target.dataset.variantUrl
    this.hideAllVariantImages()
    this.showVariantImage(event)
    this.variantButtons.forEach((el) => {
      el.classList.remove('active')
    })

    event.target.classList.add('active')
  }

  async hideAllVariantImages() {
    this.querySelectorAll('[data-variant-color]').forEach((element) => {
      element.classList.remove('active')
    })
  }

  async showVariantImage(event) {
    const vname = event.target.dataset.variantName
    const selector = '[data-variant-color="' + vname + '"]'
    const swatch = this.querySelector(selector)
    swatch?.classList.add('active')
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-card', HHProductCard)
